import axios from "axios";
import { MYINSIGHTS_ERRORS } from "@/static/myinsights-error-lookup";
import { SALES_DATA_API_ERROR_MESSAGES } from "@/static/global-variables";

function errorHandler(error) {
  return new Promise((resolve, reject) => {
    reject(error);
  });
}

class SalesDataClient {
  constructor(crmURL, crmVersion, sfEndpoint) {
    this._crmURL = crmURL;
    this._crmVersion = crmVersion;
    this._sfEndpoint = sfEndpoint;
  }

  fetchSalesData(eventInfo) {
    const url = `${this._crmURL}/${this._crmVersion}/api/v1/analytics-data/account-sales-summary`;
    const queryObject = eventInfo.object;
    const queryFields = eventInfo.fields;
    const resultLimit = eventInfo.limit;
    const sortFields = Array.isArray(eventInfo.sort) ? eventInfo.sort : [];
    const whereClause = eventInfo.where || "";
    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint
      }
    };

    const data = {
      queryObject,
      queryFields,
      resultLimit,
      sortFields,
      whereClause
    };

    return axios.post(url, data, config).then(resp => {
      // 0 means SUCCESS, -1 means FAILURE in this endpoint
      if (resp.data && resp.data.status === 0) {
        let data = resp.data.data;
        if (typeof data === "object" && Object.keys(data).length === 0) {
          data = [];
        }
        let output = {
          success: true,
          record_count: data.length
        };

        output[queryObject] = data;
        return output;
      } else {
        let output = {
          ...MYINSIGHTS_ERRORS.saleData.DEFAULT,
          success: false
        };
        if (!resp.data) {
          return output;
        }

        if (
          resp.data.message === SALES_DATA_API_ERROR_MESSAGES.noAccountToQuery
        ) {
          output.code = MYINSIGHTS_ERRORS.saleData.PDRP_OPT_OUT.code;
          output.message = MYINSIGHTS_ERRORS.saleData.PDRP_OPT_OUT.message;
        } else if (
          resp.data.message ===
          SALES_DATA_API_ERROR_MESSAGES.failedToGetAnalyticsFileObject
        ) {
          output.code = MYINSIGHTS_ERRORS.saleData.INVALID_DATA_TYPE.code;
          output.message = MYINSIGHTS_ERRORS.saleData.INVALID_DATA_TYPE.message;
        } else {
          // pass through
          output.message = resp.data.message;
        }
        return output;
      }
    }, errorHandler);
  }
}

export default SalesDataClient;
